
import { GameManager } from "../GameManager"; 
import { GameVars } from "../GameVars";

export class BootScene extends Phaser.Scene {

    public static bootedInWrongOrientation: boolean;

    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
    }

    public create(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Supercell", fontSize: 28, color: "#A6F834" });

        GameManager.setCurrentScene(this);

        GameVars.isDesktop = window.innerWidth > window.innerHeight;

        if (!GameVars.isDesktop) {

            const w = window.innerWidth;
            const h = window.innerHeight;

            if (w < h) {

                BootScene.bootedInWrongOrientation = false;
                GameManager.init();
                
            } else {

                BootScene.bootedInWrongOrientation = true;

                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none"; 
            }  

        } else {
            GameManager.init();
        }
    }
}
